module.exports = __webpack_public_path__ + "static/media/error-24px.348aa112.svg";